import { animate, state, style, transition, trigger } from '@angular/animations';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthService } from './core/authentication/auth.service';
import { AccountService } from './core/services/account.service';
import { IndexService } from './core/services/index.service';
import { UiService } from './core/services/ui.service';
// import { environment } from '@environments/environment';
 import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('splashScreen', [
      // ...
      state('show', style({
        opacity: 1,
        // zIndex: 9999
      })),
      state('hide', style({
        opacity: 0,
        // zIndex: -1
      })),
      transition('show => hide', [
        animate('0.4s')
      ]),
      // transition('hide => show', [
      //   animate('0.2s')
      // ]),
    ])
  ],
})

export class AppComponent implements OnInit, OnDestroy {
  environment = this.envConfigurationService.environment;
  title = 'PACO - ' + this.environment.application;
  isAuth = false;

  isRouteLoading = false;
  visibleSplashScreen = false;

  private subscription = new Subscription();


  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private accountService: AccountService,
    private indexService: IndexService,
    private uiService: UiService,
    public envConfigurationService: EnvConfigurationService
  ) {
    translate.setDefaultLang('fr');
  }


  ngOnInit(): void {
    this.isAuth = this.authService.isAuth();
    this.getCurrentUser();
    this.getMasterIndex();
    this.getCurrentIndex();
    this.subscription.add(
      this.authService.authChanged.subscribe(value => {
        this.isAuth = value;
        this.getCurrentUser();
        this.getMasterIndex();
        this.getCurrentIndex();
      })
    );

    this.subscription.add(
      this.uiService.isRouteLoading.subscribe(value => this.isRouteLoading = value)
    );
    this.subscription.add(
      this.uiService.visibleSplashScreen.subscribe(value => this.visibleSplashScreen = value)
    );
  }

  getCurrentUser() {
    if (this.isAuth) {
      this.accountService.getCurrentUser().subscribe();
    } else {
      this.accountService.currentUser.next(null);
    }
  }
  getMasterIndex() {
    if (this.isAuth && this.environment.application == 'supervision') {
      this.indexService.getMasterIndex();
    }
  }

  getCurrentIndex() {
    if (this.isAuth && this.environment.application == 'supervision') {
      this.indexService.getCurrentIndex();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onAnimationEvent(event: { fromState: string; toState: string; element: { style: { zIndex: number; }; }; }) {
    if ((event.fromState === 'show' || event.fromState === 'void') && event.toState === 'hide') {
      event.element.style.zIndex = -1;
    }
    if (event.toState === 'show') {
      event.element.style.zIndex = 9999;
    }
  }
}

Object.defineProperty(MatInput.prototype, 'required', {
  get(): boolean {
    if (this._required) {
      return this._required;
    }

    // The required attribute is set
    // when the control return an error from validation with an empty value
    if (this.ngControl && this.ngControl.control && this.ngControl.control.validator) {
      const emptyValueControl = Object.assign({}, this.ngControl.control);
      (emptyValueControl as any).value = null;
      return 'required' in (this.ngControl.control.validator(emptyValueControl) || {});
    }
    return false;
  },
  set(value: boolean) {
    this._required = coerceBooleanProperty(value);
  }
});

Object.defineProperty(MatSelect.prototype, 'required', {
  get(): boolean {
    if (this._required) {
      return this._required;
    }

    // The required attribute is set
    // when the control return an error from validation with an empty value
    if (this.ngControl && this.ngControl.control && this.ngControl.control.validator) {
      const emptyValueControl = Object.assign({}, this.ngControl.control);
      (emptyValueControl as any).value = null;
      return 'required' in (this.ngControl.control.validator(emptyValueControl) || {});
    }
    return false;
  },
  set(value: boolean) {
    this._required = coerceBooleanProperty(value);
  }
});